import {
  SaltoSpaceAccessPoint,
  useGetSaltoSpaceAccessPoints,
} from '@/api/keyless/salto-space/get-salto-space-access-points'
import { useUpdateSaltoSpaceConnection } from '@/api/property-keyless/salto-space/update-salto-space-connection'

import { SaltoSpaceConnectionFormValues } from './salto-space.schema'

const findName = (list: SaltoSpaceAccessPoint[], id: string) =>
  list.find((item) => item.saltoId === id)?.name ?? ''

export const useSaltoSpaceSubmit = (buildingId: number) => {
  // Note: same query key as useSaltoSpaceConnection — this is a cache hit, not an extra
  // network call. Needed here to look each selected id's name back up, since the save
  // payload needs {ExtZoneID/ExtGroupID, name} pairs, matching the legacy onSubmit shape.
  const { data: accessPoints } = useGetSaltoSpaceAccessPoints({ buildingId })
  const { mutateAsync, isPending } = useUpdateSaltoSpaceConnection()

  const submit = (values: SaltoSpaceConnectionFormValues) => {
    const zones = accessPoints?.permissionGroups ?? []
    const levels = accessPoints?.accessLevels ?? []

    return mutateAsync({
      apiKey: values.apiKey,
      buildingId,
      config: {
        accessLevels: values.residentAccessLevelIds.map((id) => ({
          ExtGroupID: id,
          name: findName(levels, id),
        })),
        permissionGroups: values.residentZoneIds.map((id) => ({
          ExtZoneID: id,
          name: findName(zones, id),
        })),
        shouldAutoAssignApartmentDoor: values.shouldAutoAssignApartmentDoor,
        shouldAutoAssignUserAccessLevel: values.shouldAutoAssignUserAccessLevel,
        visitorAccessLevels: values.visitorAccessLevelIds.map((id) => ({
          ExtGroupID: id,
          name: findName(levels, id),
        })),
        visitorPermissionGroups: values.visitorZoneIds.map((id) => ({
          ExtZoneID: id,
          name: findName(zones, id),
        })),
      },
      url: values.url,
    })
  }

  return { isPending, submit }
}
